'use es6';

import get from 'transmute/get';
import { createSelector } from 'reselect';
import { getLatestWidgetData } from '../../widget-data/selectors/getLatestWidgetData';
export const getShowingHsBranding = createSelector(getLatestWidgetData, get('showingHsBranding'));